<message-popup></message-popup>
@if (
  (auth.error$ | async) || ((auth.isAuthenticated$ | async) && languageLoaded)
) {
  <mat-sidenav-container autosize>
    @if ((auth.isAuthenticated$ | async) && languageLoaded) {
      <mat-sidenav
        #navDrawer
        opened
        mode="side"
        [ngClass]="{
          sidenav: true,
          'sidenav-collapsed': drawerService.sidenavCollapsed$ | async
        }">
        <sidebar></sidebar>
      </mat-sidenav>
    }
    <mat-sidenav-content>
      <navbar></navbar>
      @if (bannerService.alertingPausedItem$ | async; as item) {
        <div
          class="pause-alerting-banner uppercase"
          [ngClass]="{
            pending: bannerService.alertingPausePending$ | async,
            expanded: bannerExpanded
          }">
          <div class="header">
            <div class="info">
              <img class="alert-icon" src="assets/icons/critical-icon.svg" />
              <div class="message">
                {{
                  item.type
                    | bannerTranslate
                      : (bannerService.alertingPausePending$ | async) ?? false
                }}
              </div>
              <img
                src="assets/icons/BLU_Info_Icon.svg"
                class="icon-button"
                (click)="bannerExpanded = !bannerExpanded" />
              <br />
            </div>
            <img
              class="icon-button"
              src="assets/icons/closed-icon-red.svg"
              (click)="closePauseAlertingBanner()" />
          </div>
          @if (
            $any(item)?.pauseAlertingWindow
              | pauseAlertingWindowLabel: (userInfoService.info$ | async)!;
            as window
          ) {
            <div if class="details">
              <div>
                <span><ng-container i18n>Paused by</ng-container></span
                >: {{ window['requestor'] }}
              </div>
              <div>
                <span><ng-container i18n>Start date</ng-container></span
                >:
                {{ window['start'] }}
              </div>
              <div>
                <span><ng-container i18n>End date</ng-container></span
                >:
                {{ window['end'] }}
              </div>
              <div class="comment">
                <span><ng-container i18n>Comment</ng-container></span
                >: {{ window['reason'] }}
              </div>
            </div>
          }
        </div>
      }
      <mat-drawer-container>
        <mat-drawer-content
          [ngClass]="{
            'pause-alerting-height': bannerService.alertingPausedItem$ | async
          }">
          @if (!((auth.error$ | async) ?? false)) {
            <div
              class="load-mask"
              [style.display]="loading ? 'initial' : 'none'">
              <img src="assets/img/bar-loader.gif" />
            </div>
          }
          <div class="page-wrapper">
            <router-outlet></router-outlet>
          </div>
        </mat-drawer-content>
      </mat-drawer-container>
    </mat-sidenav-content>
  </mat-sidenav-container>
} @else {
  <img class="redirect-loader" src="assets/img/bar-loader.gif" />
}
